<template>
  <!-- 大学详情页院校标签 -->
  <div class="pc-dataDetail-tags">
    <h2>{{ dataDetail.msgTitle }}标签</h2>
    <!-- <h2>{{dataDetail}}</h2> -->
    <!-- <ul>
         
    </ul> -->
    <ul >
      <li v-for="item in filterArr" :key="item.id" v-if='item'>
        <div class="li uneditable">
          <span>{{ item }}</span>
        </div>
      </li>
      <li v-for="(item, index) in dataDetail.tags" :key="index">
        <template v-if="item.type != 'auto' && isShowTag(item)">
          <div class="li" :class="managerState ? 'managerClass' : 'li'">
            <span>{{ item.name }}</span>
            <i
              v-show="managerState"
              @click="removeTypeTag(index, item.practiceId)"
              class="el-icon-close"
            ></i>
          </div>
        </template>
      </li>

      <li v-show="managerState" @click="addAreaTag">添加标签</li>
    </ul>
    <!-- 添加标签的模态框 -->
    <el-dialog :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item>
          <el-select
            v-model="form.tagType"
            placeholder="选择标签分类"
            @change="selectChanged"
          >
            <el-option
              v-for="(item, index) in typeTagList"
              :key="index"
              :label="item.name"
              :value="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="form.tag"
            @change="selectTwiceChanged"
            placeholder="选择标签"
          >
            <el-option
              v-for="(item, index) in secondLevel"
              :key="index"
              :label="item.name"
              :value="index"
            ></el-option>
            <!-- <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          v-if="addAreaType"
          :disabled="formSelect"
          type="primary"
          @click="checkTag"
          >新 增</el-button
        >
      </div>
    </el-dialog>
    <DeleteDialog
      @isDelete="isDelete"
      @isCancel="isCancel"
      :dialogVisible="deleteShow"
      :delid="deleteId"
    />
  </div>
</template>
<script>
// 页面模板
import DeleteDialog from "../template/DeleteDialog";
import { getTagTypes } from "./graphql/typeTag.gql";
export default {
  props: { dataDetail: Object, managerState: Boolean, filterArr: Array },
  components: {
    DeleteDialog,
  },
  //   watch
  data() {
    return {
      // 添加标签模态框
      dialogFormVisible: false,
      form: {
        tagType: "",
        tag: "",
        type: [],
        name: "",
      },
      formSelect: true,
      // 标签数组
      typeTagList: [],
      tag: [],
      // 查询选中是哪个标签
      secondLevel: [],
      // 判断
      addAreaType: false,
      // 删除弹框的显示隐藏
      deleteShow: false,
      // 删除面板的Id
      deleteId: "-1",
      // 标签接口
    };
  },
  mounted() {
    this.getTagTypes();
  },
  methods: {
    // 标签下拉框显示
    getTagTypes() {
      this.$global
        .GraphqlQuery(this, getTagTypes, this.dataDetail)
        .then((res) => {
          this.typeTagList = res.data;
        });
    },
    // 添加地名标签
    addAreaTag() {
      this.addAreaType = true;
      this.dialogFormVisible = true;
    },
    // 选择标签分类
    selectChanged(item) {
      this.secondLevel = this.typeTagList[item].tags;

      if (this.secondLevel.length == 0) {
        // console.log(this.secondLevel)
        this.formSelect = false;
        this.secondLevel = [{ name: "暂无，请不要点新增" }];
        // console.log(this.secondLevel)
      } else {
        // console.log('dd',this.secondLevel)
        this.form.name = this.secondLevel[0].name;
        this.formSelect = false;
        this.form.tag = 0;
      }
    },
    // 选择二级标签
    selectTwiceChanged(id) {
      this.formSelect = false;
      this.form.name = this.secondLevel[id].name;
    },
    //
    isShowTag(item) {
      let isShow = true;
      this.filterArr.forEach((arr) => {
        if (item.name == arr) {
          isShow = false;
        }
      });
      return isShow;
    },
    // 详情页新增标签
    checkTag() {
      console.log(this.dataDetail);
      this.dataDetail.tags.push({
        name: this.form.name,
        // practiceId: parseFloat(this.dataDetail.id),
        weight: "0",
        type: "manual",
      });
      // let { status, tags } = this.dataDetail;
      // const subEntity = {
      //   status,
      //   tags
      // };

      this.loading = false;
      this.addAreaType = false;
      this.dialogFormVisible = false;

      this.$emit("updateTag", this.dataDetail.tags);
    },
    // 移除该标签
    removeTypeTag(index, id) {
      this.dataDetail.tags.splice(index, 1);
      // this.deleteShow=true
      this.$emit("updateTag", this.dataDetail.tags);
    },
    isCancel() {
      this.deleteShow = false;
    },
    isDelete(id) {
      console.log("chakanisss", this.dataDetail.tags);
      this.$emit("isDeletes", id);
      this.deleteShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
// 大学院校标签
.pc-dataDetail-tags {
  box-shadow: $boxshadow;
  padding: 35px 30px 20px;
  margin-top: 40px;
  > h2 {
    border-bottom: 1px solid $border-color;
    font-size: 20px;
    padding-bottom: 15px;
    color: $mainTitle;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;
    li {
      //  min-width: 70px;
      //   height: 40px;
      //   text-align: center;
      //   padding: 9px 21px;
      //   border: 1px solid $universityBorder;
      //   background: $universityBackground;
      //   margin-right: 20px;
      //   margin-bottom: 20px;
      //   color: $timeBtn;
      //   font-size: 14px;
      //   font-family: $english;
      //   border-radius: 4px;
      //   .el-icon-close {
      //     margin-left: 5px;
      //   }
      .li {
        min-width: 70px;
        height: 40px;
        text-align: center;
        padding: 9px 21px;
        border: 1px solid $universityBorder;
        background: $universityBackground;
        margin-right: 20px;
        margin-bottom: 20px;
        color: $timeBtn;
        font-size: 14px;
        font-family: $english;
        border-radius: 4px;
        .el-icon-close {
          margin-left: 5px;
        }
      }
      .uneditable {
        background: $iconFinish;
        color: $base-color;
        border: 1px solid $base-color;
      }
      .managerClass {
        transition: transform 0.3s;
      }
      .managerClass:hover {
        transform: translateY(-10px);
        cursor: pointer;
      }
    }
    li:last-child {
      height: 40px;
      border: 1px dashed $timeBtn;
      background: none;
      cursor: pointer;
      padding: 9px 21px;
      border-radius: 4px;
      color: $timeBtn;
      font-size: 14px;
      font-family: $english;
    }
  }
}
// elForm 弹出框的样式
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/template/TagDetail.vue